import Cart from "../features/cart/Cart";
import Footer from "../features/common/Footerfirst";
import NavBar from "../features/navbar/Navbar-admin";

function CartPage() {
  return (
    <>
      <NavBar />
      <Cart />
      <Footer />
    </>
  );
}

export default CartPage;
